import { applyFilters, doRequest, downloadFile } from "./helpers";

export default class CampaignTargetCallService {
  static async getTable(filters = null) {
    let path = `/call/`;
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }

  static async getCall(call_id) {
    let path = `/call/${call_id}`;
    return doRequest("GET", path);
  }

  static async getTranscript(call_id) {
    return doRequest("GET", `/call/${call_id}/transcript`);
  }

  static async swapTranscriptSpeakers(call_id, swapped) {
    return doRequest("PUT", `/call/${call_id}/transcript/speakers`, {
      data: { swapped },
    });
  }

  static async downloadTranscript(call_id) {
    return downloadFile(`/call/${call_id}/transcript/download`);
  }

  // Resolves once every selected call has been decided, so the response can
  // say what happened to each one.
  static async requestTranscriptions(call_ids) {
    return doRequest("POST", "/call/transcripts/requests", {
      data: { call_ids },
    });
  }

  // Queues a DataJob and resolves once it is accepted, not once the archive is
  // ready; the file arrives by email and on the Data tab.
  static async exportTranscripts(call_ids) {
    const path = applyFilters(
      { ids: call_ids.join(",") },
      "/call/transcripts/export"
    );
    return doRequest("GET", path);
  }

  static async getForFilters(filters = null) {
    let path = "/call/for_filters";
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }

  static async postCall(data) {
    return doRequest("POST", "/call/", {
      data: {
        attachments: data.attachments,
        campaign_id: data.campaignId,
        contact_id: data.contactId,
        entity_id: data.entityId,
        case_id: data.caseId,
        revenue_opportunity_id: data.revenue_opportunity_id,
        call_direction: data.callDirection,
        call_status: data.callStatus,
        disposition_id: data.dispositionId,
        phone_number: data.phoneNumber,
        recording: data.recording,
        transcript: data.transcript,
        comments: data.comments,
        date: data.date,
      },
    });
  }

  static async editCall(data) {
    return doRequest("PUT", `/call/${data.callId}`, {
      data: {
        disposition_id: data.dispositionId,
        status_verified: data.statusVerified,
        campaign_id: data.campaignId,
        agent_id: data.creatorUserId,
        contact_id: data.contactId,
        entity_id: data.entityId,
        status: data.status,
        tags: data.tags,
      },
    });
  }

  static async deleteCall(call_id) {
    return doRequest("DELETE", `/call/${call_id}`);
  }

  static async hangup(callSid, data) {
    return doRequest("PUT", `/call/${callSid}/hangup`, { data });
  }

  static async getCallInfo(callSid) {
    let path = `/call/${callSid}`;
    return doRequest("GET", path);
  }

  static async linkContactToCalls({ externalNumber, contactId }) {
    return doRequest("POST", "/call/link_contact", {
      data: {
        external_number: externalNumber,
        contact_id: contactId,
      },
    });
  }

  static async getNumberInfo(filters = null) {
    let path = `/call/get_numbers_for_filters`;
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }
}
